import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const MobileBoardLayout = lazy(() => import('@/pages/board/mobile/Board'));
const MobileBoardList = lazy(() => import('@/pages/board/mobile/BoardList'));
const MobileBoardDetail = lazy(() => import('@/pages/board/mobile/BoardDetail'));
const MobileBoardCreate = lazy(() => import('@/pages/board/mobile/BoardCreate'));
const MobileBoardEdit = lazy(() => import('@/pages/board/mobile/BoardEdit'));

const mobileBoardRoutes: RouteObject[] = [
  {
    path: '/boards',
    element: <MobileBoardLayout />,
    children: [
      {
        index: true,
        element: <MobileBoardList />
      },
      {
        path: ':boardId',
        element: <MobileBoardList />
      },
      {
        path: 'articles/:articleId',
        element: <MobileBoardDetail />
      },
      {
        path: ':boardId/create',
        element: <MobileBoardCreate />
      },
      {
        path: ':boardId/edit',
        element: <MobileBoardEdit />
      }
    ]
  }
];

export default mobileBoardRoutes;
